import { makeStyles } from "@material-ui/core";

export const FooterStyles = makeStyles((theme) => ({
  bottom: {
    bottom: "1px",
    padding: theme.spacing(2),
    borderTop: "1px solid lightgray",
    backgroundColor: "white",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center",
    },
  },
  help: {
    width: "100px",
    textDecoration: "none",
    color: "#666666",
    fontFamily: "Lato",
  },
}));
